import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import MainMenu from "./header-menu";
import MobileMenuOne from "./menu_sidebar/menu-one";
import SideBar from "./offcanvas";
import { getCMSGeneral } from "../../utils/cms.utils";

const HeaderTwo = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [menuSidebar, setMenuSidebar] = useState(false);
    const [isSticky, setIsSticky] = useState(false);

    const [general, setGeneral] = useState(null);

    /* ================= LOAD CMS ================= */
    useEffect(() => {
        setGeneral(getCMSGeneral());
    }, []);

    /* ================= STICKY ================= */
    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    if (!general) return null;

    return (
        <>
            <div
                className={`header__area two header__sticky ${
                    isSticky ? "header__sticky-sticky-menu" : ""
                }`}
            >
                <div className="custom_container">
                    <div className="header__area-menubar">

                        {/* ===== LEFT / LOGO ===== */}
                        <div className="header__area-menubar-left one">
                            <div className="header__area-menubar-left-logo">
                                <Link to="/">
                                    <img
                                        src={isSticky ? general?.logo2 : general?.logo1}
                                        alt={general?.companyName}
                                    />
                                </Link>
                            </div>
                        </div>

                        {/* ===== CENTER / MENU ===== */}
                        <div className="header__area-menubar-center">
                            <div className="header__area-menubar-center-menu">
                                <MainMenu />
                            </div>
                        </div>

                        {/* ===== RIGHT ===== */}
                        <div className="header__area-menubar-right">
                            <div className="header__area-menubar-right-sidebar">
                                <div
                                    className="header__area-menubar-right-sidebar-icon"
                                    onClick={() => setSidebarOpen(true)}
                                >
                                    <i className="flaticon-menu-6"></i>
                                </div>
                            </div>

                            <div className="header__area-menubar-right-responsive-menu menu__bar">
                                <i
                                    className="flaticon-menu-3"
                                    onClick={() => setMenuSidebar(true)}
                                ></i>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ===== OFFCANVAS ===== */}
            <SideBar
                isOpen={sidebarOpen}
                setIsOpen={setSidebarOpen}
                general={general}
            />

            {/* ===== MOBILE MENU ===== */}
            <MobileMenuOne
                isOpen={menuSidebar}
                setIsOpen={setMenuSidebar}
                general={general}
            />
        </>
    );
};

export default HeaderTwo;
